/* GENERATED by scripts/gen-data.mjs — chapter "what-ai-is" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_WHAT_AI_IS: NodeDef = {
  "id": "what-ai-is",
  "tagKey": "path:what-ai-is.tag",
  "x": 40,
  "y": 40,
  "w": 220,
  "h": 116,
  "titleKey": "path:what-ai-is.title",
  "subKey": "path:what-ai-is.sub",
  "blocks": [
    {
      "id": "what-ai-is.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:what-ai-is.b1.title",
      "bodyKey": "path:what-ai-is.b1.body",
      "flowKey": "path:what-ai-is.b1.flow"
    },
    {
      "id": "what-ai-is.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:what-ai-is.b2.title",
      "film": "f-foundations"
    },
    {
      "id": "what-ai-is.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:what-ai-is.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:what-ai-is.b3o.opts.0.n",
            "wKey": "path:what-ai-is.b3o.opts.0.w",
            "uKey": "path:what-ai-is.b3o.opts.0.u",
            "cKey": "path:what-ai-is.b3o.opts.0.c",
            "slug": "rule-engine"
          },
          {
            "nKey": "path:what-ai-is.b3o.opts.1.n",
            "wKey": "path:what-ai-is.b3o.opts.1.w",
            "uKey": "path:what-ai-is.b3o.opts.1.u",
            "cKey": "path:what-ai-is.b3o.opts.1.c",
            "slug": "fine-tuned-small-model"
          },
          {
            "nKey": "path:what-ai-is.b3o.opts.2.n",
            "wKey": "path:what-ai-is.b3o.opts.2.w",
            "uKey": "path:what-ai-is.b3o.opts.2.u",
            "cKey": "path:what-ai-is.b3o.opts.2.c",
            "slug": "zero-shot-classifier"
          },
          {
            "nKey": "path:what-ai-is.b3o.opts.3.n",
            "wKey": "path:what-ai-is.b3o.opts.3.w",
            "uKey": "path:what-ai-is.b3o.opts.3.u",
            "cKey": "path:what-ai-is.b3o.opts.3.c",
            "slug": "generative-model-with-tools"
          }
        ],
        "ref": "zshot"
      }
    },
    {
      "id": "what-ai-is.b3",
      "kind": "math",
      "xp": 15,
      "titleKey": "path:what-ai-is.b3.title",
      "math": {
        "exprKey": "path:what-ai-is.b3.math.expr",
        "readKey": "path:what-ai-is.b3.math.read",
        "useKey": "path:what-ai-is.b3.math.use",
        "ref": "attn"
      }
    },
    {
      "id": "what-ai-is.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:what-ai-is.b4.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:what-ai-is.b4.ex.bins",
        "binCount": 2,
        "items": [
          {
            "tKey": "path:what-ai-is.b4.ex.items.0.t",
            "bin": 0,
            "whyKey": "path:what-ai-is.b4.ex.items.0.why"
          },
          {
            "tKey": "path:what-ai-is.b4.ex.items.1.t",
            "bin": 1,
            "whyKey": "path:what-ai-is.b4.ex.items.1.why"
          },
          {
            "tKey": "path:what-ai-is.b4.ex.items.2.t",
            "bin": 0,
            "whyKey": "path:what-ai-is.b4.ex.items.2.why"
          },
          {
            "tKey": "path:what-ai-is.b4.ex.items.3.t",
            "bin": 1,
            "whyKey": "path:what-ai-is.b4.ex.items.3.why"
          }
        ]
      }
    }
  ]
};
